module.exports = __webpack_public_path__ + "img/pussy-talk-bg.4f64706f.svg";